/**
 * Module front PUR (sans jQuery ni DOM) — formatage de la saisie ".input-currency" au focusout,
 * extrait à l'identique et dédupliqué entre `simulation.js` et `simulation_borne.js` (bloc
 * byte-identique dans les 2 fichiers).
 *
 * Distinct de modules/number-format.js (regex de groupement des milliers différente, bien
 * qu'équivalente sur des chaînes purement numériques) : non fusionné pour rester rigoureusement
 * byte-identique à l'original plutôt que de dépendre d'une équivalence de comportement entre 2
 * implémentations distinctes de regex.
 *
 * CommonJS (require/module.exports) pour être exécutable par Jest sans transpilation ; consommable par Webpack.
 */
'use strict';

/** "0012345" -> "12 345 FCFP" (retire les zéros de tête, groupe les milliers, ajoute la devise). */
function formatCurrencyInputValue(value) {
    // remove 0 before number
    const noneZero = value.replace(/^0+/, '');

    // add space for thousand
    const valueWithCommma = noneZero.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1 ");

    // add currency
    return valueWithCommma + ' FCFP';
}

module.exports = {
    formatCurrencyInputValue: formatCurrencyInputValue
};
